import { Component, HostListener } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BreadCrumb } from './shared/models/components';
import { AppState } from './shared/models/state';
import { ApiService } from './shared/services/api.service';
import { ContextService } from './shared/services/ctx.service';
import { EventsService } from './shared/services/events.service';
import { CommonHelper } from './shared/services/helpers/common.service';
import { NavService } from './shared/services/nav.service';
import { StateService } from './shared/services/state.service';
import { UiService } from './shared/services/ui.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.events.backEvent$.next(true);
  }

  @HostListener('window:resize', ['$event'])
  private onResize(e) {
    this.events.onResize(e.target.innerWidth);
  }

  isDesktop: boolean;
  showBackButton: boolean;
  headerTitle: string;
  userIdentified: boolean;
  showSpinner: boolean;
  state: Partial<AppState>;

  constructor(
    private events: EventsService,
    private translate: TranslateService,
    private router: Router,
    private stateService: StateService,
    private ctx: ContextService,
    private ui: UiService,
    private commonHelper: CommonHelper,
    private nav: NavService,
  ) {
    this.userIdentified = null;
    this.setEnvironment();
    this.initAppState();
    this.initLanguage();
    this.onPageChange$();
    this.handlerEvents();
  }

  private handlerEvents() {
    this.stateService.getState().subscribe(state => {
      this.state = state;
    });

    this.ui.checkSpinner().subscribe(show => {
      this.showSpinner = show;
    });

    this.events.backEvent().subscribe(v => {
      const previousUrl = this.router.url;
      this.ctx.browserBack = v;
      const state = this.stateService.getStateValue();
      if (v && previousUrl === '/doctors-centers' && !state.userIdentified) this.commonHelper.identifyUser();
    });

    this.events.isDesktopView().subscribe(isDesktop => {
      this.isDesktop = isDesktop;
      this.stateService.updateState({ ...this.state, isDesktop });
    });
  }

  private initAppState() {
    this.stateService.initAppState({
      breadcrumbs: this.getBreadcrumbsBasePath(),
      // descomentar para mockear las llamadas al back
      develop: sessionStorage.getItem('MOCK_APP') ? true : false
    });
  }

  private setEnvironment() {
    this.ctx.environment = this.ctx.getEnvironment();
  }

  private async initLanguage() {
    this.translate.use('es').subscribe({
      error: () => console.log(this, `Error using spanish language`)
    });
  }

  public throwTestError(): void {
    throw new Error("Sentry Test Error 1");
  }

  private getBreadcrumbsBasePath(): [BreadCrumb, BreadCrumb] {
    return [{ label: 'Home' }, { label: 'MAPFRE Salud' }];

  }

  onPageChange$() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.ctx.isFirstPage$.next(false);

        if (this.userIdentified === null) {
          this.userIdentified = true;
          this.commonHelper.identifyUser();
        }

        const state = this.router.getCurrentNavigation()?.extras?.state || {};
        this.showBackButton = state['back'];
        this.headerTitle = state['headerTitle'];

      }
    });
  }

  showFullFooter() {
    return this.nav.getLocationPath() === 'home';
  }

}
